var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaultIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.62992 11.4248C4.57533 10.9893 4.54736 10.5499 4.54736 10.0999C4.54736 4.52996 8.80036 0 14.0227 0C19.2451 0 23.4981 4.52996 23.4981 10.0999C23.4981 10.5499 23.4701 10.9893 23.4155 11.4248C21.5886 7.9241 18.0627 5.54993 14.0227 5.54993C9.98278 5.54993 6.45815 7.92543 4.62992 11.4248Z",
    fill: "url(#paint0_linear_4344_2553)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91478 26.225C3.23036 23.94 0 19.0998 0 13.5006C0 7.9014 3.23036 3.05985 7.91478 0.774902C5.12783 2.8255 3.29694 6.23961 3.29694 10.0998C3.29694 11.2849 3.47004 12.4247 3.78695 13.4993C3.47004 14.5738 3.29694 15.7136 3.29694 16.8987C3.29694 20.7563 5.1265 24.1717 7.91478 26.2236V26.225Z",
    fill: "url(#paint1_linear_4344_2553)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0227 27C8.80036 27 4.54736 22.4674 4.54736 16.9001C4.54736 16.4501 4.57533 16.008 4.62992 15.5726C6.45682 19.0732 9.98278 21.4501 14.0227 21.4501C18.0627 21.4501 21.5873 19.0719 23.4155 15.5726C23.4701 16.008 23.4981 16.4501 23.4981 16.9001C23.4981 22.4674 19.2478 27 14.0227 27Z",
    fill: "url(#paint2_linear_4344_2553)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 13.5006C28.0001 19.0425 24.835 23.8428 20.2278 26.1531C22.9628 24.0931 24.7484 20.7137 24.7484 16.9001C24.7484 15.715 24.5753 14.5752 24.2584 13.5006C24.5753 12.426 24.7484 11.2862 24.7484 10.1011C24.7484 6.28623 22.9628 2.90673 20.2278 0.848145C24.835 3.1584 28.0001 7.956 28.0001 13.5006Z",
    fill: "url(#paint3_linear_4344_2553)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4344_2553",
    x1: 14.0227,
    y1: -3.70885e-9,
    x2: 14.0978,
    y2: 16.3749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4344_2553",
    x1: 3.95739,
    y1: 0.774902,
    x2: 3.95739,
    y2: 26.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4344_2553",
    x1: 14.0227,
    y1: 15.5726,
    x2: 14.0227,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4344_2553",
    x1: 24.1139,
    y1: 0.848145,
    x2: 24.1139,
    y2: 26.1531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CFBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBDAF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaultIcon);
export default __webpack_public_path__ + "static/media/wault-icon.8e6798ad6ae515d7560949efe53e49db.svg";
export { ForwardRef as ReactComponent };